export const BUTTON = 'button';
export const GROUP = 'group';
export const CAROUSEL = 'carousel';
export const VIDEO = 'video';



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/constants/componentTypes.js